import { ref, onMounted, onBeforeUnmount } from 'vue';

export function useAutoDismiss(callback: () => void, delay: number) {
    const timer = ref<number | null>(null);

    onMounted(() => {
        timer.value = window.setTimeout(callback, delay);
    });

    onBeforeUnmount(() => {
        if (timer.value !== null) {
            clearTimeout(timer.value);
        }
    });

    function cancel() {
        if (timer.value !== null) {
            clearTimeout(timer.value);
            timer.value = null;
        }
    }

    return { cancel };
}
